
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 2220","d":"M17.014 15.28a3.33 3.33 0 001.433-1.5 5.085 5.085 0 00.4-2.895 6.332 6.332 0 00-2.683-4.5A7.381 7.381 0 0011.882 5a6.769 6.769 0 00-1.468.159 6.981 6.981 0 00-5.141 8.714 7.024 7.024 0 001.473 2.66 6.956 6.956 0 008.718 1.357l-.719-1.2a5.536 5.536 0 01-8.134-3.209 5.588 5.588 0 014.1-6.961 5.873 5.873 0 014.63.993 4.953 4.953 0 012.11 3.516 3.829 3.829 0 01-.248 2.114 1.6 1.6 0 01-1.685 1.036h-.025l-.025-.005-.016-.022a2.237 2.237 0 01-.083-.894V8.914h-1.113l-.017-.014a3.87 3.87 0 00-.462-.325 4.146 4.146 0 00-4.891.52 3.991 3.991 0 00-.894 4.447 3.721 3.721 0 001.525 1.714 4.255 4.255 0 002.17.582 4.062 4.062 0 002.365-.71c.07-.049.139-.1.205-.155l.049-.039.037.05a1.435 1.435 0 00.976.572 2.8 2.8 0 001.695-.278m-3.049-2.03l-.011.015c-.032.046-.079.1-.108.139l-.059.074a2.522 2.522 0 01-.541.514 2.651 2.651 0 01-1.561.454 2.5 2.5 0 01-1.845-4.33 2.717 2.717 0 011.85-.714 2.669 2.669 0 011.373.371 2.482 2.482 0 01.678.6l.063.076c.032.038.1.127.15.192l.011.016z","fill":"currentColor"}})])
          )
        }
      }
    